import { Paths } from '../../lib/constants/path'
import { RoleEnum } from '../../lib/types/enums/users/role.enum'
import { Route } from '../../lib/types/routes'
import ClientPersonalSpaceLayout from './client-personal-space-layout'
import ClientHomePage from './home/client-home'
import ClientIdentityPage from './informations/client-identity'
import ClientIndividualTripPage from './informations/client-individual-trip'
import ClientInformationChildProfile from './informations/client-information-child-profile'
import ClientInformationsTestPage from './informations/client-informations-test'
import ClientMedicalStatementPage from './informations/client-medical-statement'
import ClientPickupPage from './informations/client-pickup'
import ClientTripsPage from './informations/client-trips'
import ClientCancelJourneyPage from './reservations/client-cancel-journey'
import ClientFinalizePaymentPage from './reservations/client-finalize-payment'
import ClientPaymentPage from './reservations/client-payment'
import ClientAdminstrationProcedures from './trip-information/client-child-adminstration-procedures'
import ClientChildDepartureChecklistPage from './trip-information/client-child-departure-checklist'
import ClientChildJourneyPreparationPage from './trip-information/client-child-journey-preparation'
import ClientLecGuidePage from './trip-information/client-lec-guide'
import ClientOtoIndividualContactPage from './trip-information/client-oto-individual-contact'
import ClientTripInformationContact from './trip-information/client-trip-information-contact'

const clientPersonalSpaceRoutes: Route[] = [
  {
    path: Paths.CLIENT_SPACE_LAYOUT,
    element: <ClientPersonalSpaceLayout />,
    roles: [RoleEnum.CLIENT],
    children: [
      {
        path: Paths.CLIENT_PERSONAL_SPACE_HOME,
        element: <ClientHomePage />,
        roles: [RoleEnum.CLIENT]
      },
      {
        path: Paths.CLIENT_PERSONAL_SPACE_INFORMATION_PICKUP,
        element: <ClientPickupPage />,
        roles: [RoleEnum.CLIENT]
      },
      {
        path: Paths.CLIENT_PERSONAL_SPACE_TRIP_INFORMATION_LEC_GUIDE,
        element: <ClientLecGuidePage />,
        roles: [RoleEnum.CLIENT]
      },
      {
        path: Paths.CLIENT_PERSONAL_SPACE_INFORMATION_IDENTITY,
        element: <ClientIdentityPage />,
        roles: [RoleEnum.CLIENT]
      },
      {
        path: Paths.CLIENT_PERSONAL_SPACE_INFORMATION_TRIPS,
        element: <ClientTripsPage />,
        roles: [RoleEnum.CLIENT]
      },
      {
        path: Paths.CLIENT_PERSONAL_SPACE_INFORMATION_INDIVIDUAL_TRIP,
        element: <ClientIndividualTripPage />,
        roles: [RoleEnum.CLIENT]
      },
      {
        path: Paths.CLIENT_PERSONAL_SPACE_INFORMATION_TEST_LEVEL,
        element: <ClientInformationsTestPage />,
        roles: [RoleEnum.CLIENT]
      },
      {
        path: Paths.CLIENT_PERSONAL_SPACE_INFORMATION_MEDICAL_STATEMENT,
        element: <ClientMedicalStatementPage />,
        roles: [RoleEnum.CLIENT]
      },
      {
        path: Paths.CLIENT_PERSONAL_SPACE_PAYMENT,
        element: <ClientPaymentPage />,
        roles: [RoleEnum.CLIENT]
      },
      {
        path: Paths.CLIENT_PERSONAL_SPACE_FINALIZE_PAYMENT,
        element: <ClientFinalizePaymentPage />,
        roles: [RoleEnum.CLIENT]
      },
      {
        path: Paths.CLIENT_PERSONAL_SPACE_CANCEL_JOURNEY,
        element: <ClientCancelJourneyPage />,
        roles: [RoleEnum.CLIENT]
      },
      {
        path: Paths.CLIENT_PERSONAL_SPACE_INFORMATION_CHILD_PROFILE,
        element: <ClientInformationChildProfile />,
        roles: [RoleEnum.CLIENT]
      },
      {
        path: Paths.CLIENT_PERSONAL_SPACE_TRIP_INFORMATION_CONTACT,
        element: <ClientTripInformationContact />,
        roles: [RoleEnum.CLIENT]
      },
      {
        path: Paths.CLIENT_PERSONAL_SPACE_TRIP_INFORMATION_OTO_CONTACT,
        element: <ClientOtoIndividualContactPage />,
        roles: [RoleEnum.CLIENT]
      },
      {
        path: Paths.CLIENT_PERSONAL_SPACE_JOURNEY_PREPARATION,
        element: <ClientChildJourneyPreparationPage />,
        roles: [RoleEnum.CLIENT]
      },
      {
        path: Paths.CLIENT_PERSONAL_SPACE_DEPARTURE_CHECKLIST,
        element: <ClientChildDepartureChecklistPage />,
        roles: [RoleEnum.CLIENT]
      },
      {
        path: Paths.CLIENT_PERSONAL_SPACE_ADMINSTRATION_PROCEDURES,
        element: <ClientAdminstrationProcedures />,
        roles: [RoleEnum.CLIENT]
      }
    ]
  }
]

export default clientPersonalSpaceRoutes
